var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88266",
    "data-name": "Group 88266",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 453.509,
    height: 431,
    viewBox: "0 0 453.509 431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25796",
    "data-name": "Rectangle 25796",
    width: 453.509,
    height: 431,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25746",
    "data-name": "Rectangle 25746",
    width: 26.3,
    height: 22.994,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25749",
    "data-name": "Rectangle 25749",
    width: 26.3,
    height: 22.996,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25757",
    "data-name": "Rectangle 25757",
    width: 57.385,
    height: 73.554,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25762",
    "data-name": "Rectangle 25762",
    width: 39.546,
    height: 50.602,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25763",
    "data-name": "Rectangle 25763",
    width: 36.01,
    height: 36.01,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25764",
    "data-name": "Rectangle 25764",
    width: 24.424,
    height: 24.423,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25765",
    "data-name": "Rectangle 25765",
    width: 36.238,
    height: 36.237,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25766",
    "data-name": "Rectangle 25766",
    width: 24.576,
    height: 24.576,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88265",
    "data-name": "Group 88265",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88264",
    "data-name": "Group 88264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88263",
    "data-name": "Group 88263",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308977",
    "data-name": "Path 308977",
    d: "M428.21,359.551c7.217-15.516,10.409-32.782,12.622-49.552,6.105-46.261,3.668-93.811-9.687-138.8C400.695,68.613,342.139,7.357,267.966.716S122.747,33.926,95.42,109.2-9.2,247.213,4.071,308.467,75.122,411.788,189.11,425.811c49.656,6.109,102.225,8.864,151.124-3.418,27.912-7.012,55.349-20.576,74.2-41.663a85.72,85.72,0,0,0,13.775-21.179",
    transform: "translate(2.947 0)",
    fill: "#fff0dd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11108",
    "data-name": "Line 11108",
    x2: 12.561,
    transform: "translate(440.455 382.663)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11109",
    "data-name": "Line 11109",
    x2: 359.579,
    transform: "translate(73.297 382.663)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11110",
    "data-name": "Line 11110",
    x2: 61.857,
    transform: "translate(0.492 382.663)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25736",
    "data-name": "Rectangle 25736",
    width: 14.572,
    height: 14.572,
    transform: "translate(223.905 82.862)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25737",
    "data-name": "Rectangle 25737",
    width: 14.572,
    height: 14.572,
    transform: "translate(223.905 82.862)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25738",
    "data-name": "Rectangle 25738",
    width: 14.574,
    height: 14.574,
    transform: "matrix(0.753, -0.658, 0.658, 0.753, 253.7, 113.715)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25739",
    "data-name": "Rectangle 25739",
    width: 14.574,
    height: 14.574,
    transform: "matrix(0.753, -0.658, 0.658, 0.753, 253.7, 113.715)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25740",
    "data-name": "Rectangle 25740",
    width: 14.574,
    height: 14.574,
    transform: "matrix(0.753, -0.658, 0.658, 0.753, 171.721, 48.787)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25741",
    "data-name": "Rectangle 25741",
    width: 14.574,
    height: 14.574,
    transform: "matrix(0.753, -0.658, 0.658, 0.753, 171.721, 48.787)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25742",
    "data-name": "Rectangle 25742",
    width: 14.574,
    height: 14.574,
    transform: "matrix(0.753, -0.658, 0.658, 0.753, 171.721, 107.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25743",
    "data-name": "Rectangle 25743",
    width: 14.574,
    height: 14.574,
    transform: "matrix(0.753, -0.658, 0.658, 0.753, 171.721, 107.812)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25744",
    "data-name": "Rectangle 25744",
    width: 14.574,
    height: 14.574,
    transform: "matrix(0.753, -0.658, 0.658, 0.753, 236.648, 48.131)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25745",
    "data-name": "Rectangle 25745",
    width: 14.574,
    height: 14.574,
    transform: "matrix(0.753, -0.658, 0.658, 0.753, 236.648, 48.131)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308978",
    "data-name": "Path 308978",
    d: "M115.325,49.808l3.088,6.258,6.907,1-5,4.87,1.181,6.881-6.178-3.25-6.178,3.25,1.181-6.881-5-4.87,6.907-1Z",
    transform: "translate(121.656 57.528)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308979",
    "data-name": "Path 308979",
    d: "M115.325,49.808l3.088,6.258,6.907,1-5,4.87,1.181,6.881-6.178-3.25-6.178,3.25,1.181-6.881-5-4.87,6.907-1Z",
    transform: "translate(121.656 57.528)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308980",
    "data-name": "Path 308980",
    d: "M90.913,29.208,94,35.466l6.907,1-5,4.87,1.181,6.881-6.178-3.25-6.178,3.25,1.181-6.881-5-4.87,6.907-1Z",
    transform: "translate(93.461 33.735)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308981",
    "data-name": "Path 308981",
    d: "M90.913,29.208,94,35.466l6.907,1-5,4.87,1.181,6.881-6.178-3.25-6.178,3.25,1.181-6.881-5-4.87,6.907-1Z",
    transform: "translate(93.461 33.735)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308982",
    "data-name": "Path 308982",
    d: "M137.342,14.023l-2.127,6.646,4.269,5.521-6.98.032-3.931,5.767-2.185-6.629-6.7-1.957,5.629-4.127-.209-6.976,5.663,4.077Z",
    transform: "translate(138.24 14.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308983",
    "data-name": "Path 308983",
    d: "M137.342,14.023l-2.127,6.646,4.269,5.521-6.98.032-3.931,5.767-2.185-6.629-6.7-1.957,5.629-4.127-.209-6.976,5.663,4.077Z",
    transform: "translate(138.24 14.208)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308984",
    "data-name": "Path 308984",
    d: "M106.283,66.609l6.926.86,4.635-5.219,1.321,6.853,6.4,2.8-6.109,3.377-.681,6.946-5.1-4.767-6.816,1.5,2.957-6.321Z",
    transform: "translate(122.756 71.898)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308985",
    "data-name": "Path 308985",
    d: "M106.283,66.609l6.926.86,4.635-5.219,1.321,6.853,6.4,2.8-6.109,3.377-.681,6.946-5.1-4.767-6.816,1.5,2.957-6.321Z",
    transform: "translate(122.756 71.898)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308986",
    "data-name": "Path 308986",
    d: "M135.448,46.3a10.243,10.243,0,1,1-10.243-10.243A10.243,10.243,0,0,1,135.448,46.3",
    transform: "translate(132.782 41.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5014",
    "data-name": "Ellipse 5014",
    cx: 10.243,
    cy: 10.243,
    r: 10.243,
    transform: "translate(247.746 77.701)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308987",
    "data-name": "Path 308987",
    d: "M117,76.544A10.243,10.243,0,1,1,106.756,66.3,10.243,10.243,0,0,1,117,76.544",
    transform: "translate(111.473 76.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5015",
    "data-name": "Ellipse 5015",
    cx: 10.243,
    cy: 10.243,
    r: 10.243,
    transform: "translate(207.986 142.879)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308988",
    "data-name": "Path 308988",
    d: "M150.17,31.619a10.243,10.243,0,1,1-10.243-10.243A10.243,10.243,0,0,1,150.17,31.619",
    transform: "translate(149.786 24.689)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5016",
    "data-name": "Ellipse 5016",
    cx: 10.243,
    cy: 10.243,
    r: 10.243,
    transform: "translate(279.472 46.066)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308989",
    "data-name": "Path 308989",
    d: "M114.754,37.778a10.243,10.243,0,1,1-10.243-10.243,10.243,10.243,0,0,1,10.243,10.243",
    transform: "translate(108.881 31.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5017",
    "data-name": "Ellipse 5017",
    cx: 10.243,
    cy: 10.243,
    r: 10.243,
    transform: "translate(203.149 59.338)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308990",
    "data-name": "Path 308990",
    d: "M108.427,52.306,92.058,42.02l-.724,19.32Z",
    transform: "translate(105.491 48.533)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308991",
    "data-name": "Path 308991",
    d: "M108.427,52.306,92.058,42.02l-.724,19.32Z",
    transform: "translate(105.491 48.533)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308992",
    "data-name": "Path 308992",
    d: "M144.532,53.8,141.4,34.726,126.443,46.982Z",
    transform: "translate(146.042 40.109)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308993",
    "data-name": "Path 308993",
    d: "M144.532,53.8,141.4,34.726,126.443,46.982Z",
    transform: "translate(146.042 40.109)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308994",
    "data-name": "Path 308994",
    d: "M110.908,73.845l.778-19.317L94.569,63.512Z",
    transform: "translate(109.227 62.98)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308995",
    "data-name": "Path 308995",
    d: "M110.908,73.845l.778-19.317L94.569,63.512Z",
    transform: "translate(109.227 62.98)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308996",
    "data-name": "Path 308996",
    d: "M134.082,43.7l.778-19.317-17.119,8.984Z",
    transform: "translate(135.991 28.164)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308997",
    "data-name": "Path 308997",
    d: "M134.082,43.7l.778-19.317-17.119,8.984Z",
    transform: "translate(135.991 28.164)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308998",
    "data-name": "Path 308998",
    d: "M94.31,16.446l10.081,16.5,9.247-16.977Z",
    transform: "translate(108.928 18.44)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308999",
    "data-name": "Path 308999",
    d: "M94.31,16.446l10.081,16.5,9.247-16.977Z",
    transform: "translate(108.928 18.44)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88226",
    "data-name": "Group 88226",
    transform: "translate(363.245 96.126)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88225",
    "data-name": "Group 88225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88224",
    "data-name": "Group 88224",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309000",
    "data-name": "Path 309000",
    d: "M169.363,67.377a.489.489,0,0,1-.491-.491V60.5c0-3.269-.31-14.777-.312-14.891a.491.491,0,0,1,.461-.5c.078-.006,7.913-.476,14.423-.237,6.467.233,9.915,0,9.95,0a.51.51,0,0,1,.362.125.49.49,0,0,1,.164.345l.937,21.291a.493.493,0,0,1-.491.515H183.114c-4.319,0-13.645.233-13.738.235Zm.192-21.319c.058,2.222.3,11.542.3,14.441v5.883c2.011-.047,9.512-.224,13.26-.224h10.738l-.894-20.283c-1.185.056-4.444.159-9.549-.026-5.547-.2-12.064.112-13.855.209",
    transform: "translate(-168.559 -44.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309001",
    "data-name": "Path 309001",
    d: "M178.076,46.763a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-161.345 -44.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309002",
    "data-name": "Path 309002",
    d: "M178.962,46.242a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-160.322 -44.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309003",
    "data-name": "Path 309003",
    d: "M174.892,47.905a.483.483,0,0,1-.364-.164.489.489,0,0,1,.034-.694l1.123-1.011a.492.492,0,0,1,.659.731l-1.123,1.011a.488.488,0,0,1-.33.127",
    transform: "translate(-161.813 -43.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309004",
    "data-name": "Path 309004",
    d: "M184.3,49.424H171.611a.491.491,0,1,1,0-.983H184.3a.491.491,0,1,1,0,.983",
    transform: "translate(-165.601 -40.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309005",
    "data-name": "Path 309005",
    d: "M185.048,51.387H171.613a.491.491,0,1,1,0-.983h13.434a.491.491,0,1,1,0,.983",
    transform: "translate(-165.601 -37.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309006",
    "data-name": "Path 309006",
    d: "M185.3,53.234H171.611a.491.491,0,1,1,0-.983H185.3a.491.491,0,0,1,0,.983",
    transform: "translate(-165.601 -35.776)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88229",
    "data-name": "Group 88229",
    transform: "translate(425.701 168.219)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88228",
    "data-name": "Group 88228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88227",
    "data-name": "Group 88227",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309007",
    "data-name": "Path 309007",
    d: "M198.345,100.831a.489.489,0,0,1-.491-.491V93.953c0-3.269-.31-14.777-.312-14.891a.491.491,0,0,1,.461-.5c.078-.006,7.913-.476,14.423-.237,6.467.233,9.915,0,9.95,0a.51.51,0,0,1,.362.125.49.49,0,0,1,.164.345l.937,21.291a.493.493,0,0,1-.491.515H212.1c-4.319,0-13.645.233-13.738.235Zm.192-21.319c.058,2.222.3,11.542.3,14.441v5.883c2.011-.047,9.512-.224,13.26-.224h10.738l-.894-20.283c-1.185.054-4.444.159-9.549-.026-5.547-.2-12.064.112-13.855.209",
    transform: "translate(-197.541 -77.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309008",
    "data-name": "Path 309008",
    d: "M207.058,80.217a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-190.327 -77.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309009",
    "data-name": "Path 309009",
    d: "M207.944,79.7a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-189.303 -78.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309010",
    "data-name": "Path 309010",
    d: "M203.874,81.359a.482.482,0,0,1-.364-.164.489.489,0,0,1,.035-.694l1.123-1.011a.492.492,0,0,1,.659.731L204.2,81.232a.488.488,0,0,1-.33.127",
    transform: "translate(-190.795 -76.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309011",
    "data-name": "Path 309011",
    d: "M213.283,82.878H200.594a.491.491,0,1,1,0-.983h12.689a.491.491,0,0,1,0,.983",
    transform: "translate(-194.582 -73.631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309012",
    "data-name": "Path 309012",
    d: "M214.03,84.839H200.6a.49.49,0,1,1,0-.981H214.03a.49.49,0,1,1,0,.981",
    transform: "translate(-194.583 -71.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309013",
    "data-name": "Path 309013",
    d: "M214.279,86.688H200.594a.491.491,0,1,1,0-.983h13.684a.491.491,0,0,1,0,.983",
    transform: "translate(-194.582 -69.23)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88232",
    "data-name": "Group 88232",
    transform: "translate(135.456 132.767)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88231",
    "data-name": "Group 88231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88230",
    "data-name": "Group 88230",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309014",
    "data-name": "Path 309014",
    d: "M63.661,84.38a.493.493,0,0,1-.491-.491V77.5c0-3.269-.31-14.777-.312-14.891a.491.491,0,0,1,.461-.5c.078-.006,7.913-.476,14.423-.237,6.467.233,9.915,0,9.95,0a.51.51,0,0,1,.362.125.49.49,0,0,1,.164.345l.937,21.291a.493.493,0,0,1-.491.515H77.412c-4.319,0-13.645.233-13.738.235Zm.192-21.319c.058,2.222.3,11.542.3,14.441v5.883c2.011-.047,9.51-.224,13.26-.224H88.15l-.894-20.283c-1.185.054-4.444.159-9.549-.026-5.547-.2-12.064.112-13.854.209",
    transform: "translate(-62.856 -61.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309015",
    "data-name": "Path 309015",
    d: "M72.374,63.766A1.636,1.636,0,1,0,70.739,65.4a1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-55.642 -61.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309016",
    "data-name": "Path 309016",
    d: "M73.261,63.245a1.637,1.637,0,1,0-1.638,1.636,1.638,1.638,0,0,0,1.638-1.636",
    transform: "translate(-54.62 -61.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309017",
    "data-name": "Path 309017",
    d: "M69.19,64.908a.483.483,0,0,1-.364-.164.489.489,0,0,1,.034-.694l1.123-1.011a.492.492,0,0,1,.659.731L69.52,64.781a.488.488,0,0,1-.33.127",
    transform: "translate(-56.11 -60.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309018",
    "data-name": "Path 309018",
    d: "M78.6,66.427H65.909a.491.491,0,0,1,0-.983H78.6a.491.491,0,0,1,0,.983",
    transform: "translate(-59.898 -57.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309019",
    "data-name": "Path 309019",
    d: "M79.346,68.39H65.912a.491.491,0,1,1,0-.983H79.346a.491.491,0,1,1,0,.983",
    transform: "translate(-59.898 -54.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309020",
    "data-name": "Path 309020",
    d: "M79.594,70.237H65.909a.491.491,0,0,1,0-.983H79.594a.491.491,0,0,1,0,.983",
    transform: "translate(-59.898 -52.779)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88235",
    "data-name": "Group 88235",
    transform: "translate(329.112 128.531)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88234",
    "data-name": "Group 88234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88233",
    "data-name": "Group 88233",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309021",
    "data-name": "Path 309021",
    d: "M153.524,82.414a.489.489,0,0,1-.491-.491V75.536c0-3.269-.31-14.777-.312-14.891a.491.491,0,0,1,.461-.5c.078-.006,7.913-.476,14.423-.237,6.467.233,9.915,0,9.95,0a.518.518,0,0,1,.362.123.5.5,0,0,1,.164.347l.937,21.291a.493.493,0,0,1-.491.515H167.275c-4.319,0-13.645.233-13.738.235Zm.192-21.319c.058,2.222.3,11.542.3,14.441v5.883c2.011-.047,9.51-.224,13.26-.224h10.738l-.894-20.283c-1.185.054-4.444.159-9.549-.026-5.547-.2-12.064.112-13.854.209",
    transform: "translate(-152.72 -59.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309022",
    "data-name": "Path 309022",
    d: "M162.237,61.8a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-145.506 -59.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309023",
    "data-name": "Path 309023",
    d: "M163.123,61.279a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-144.483 -59.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309024",
    "data-name": "Path 309024",
    d: "M159.053,62.942a.483.483,0,0,1-.364-.164.489.489,0,0,1,.035-.694l1.123-1.011a.492.492,0,0,1,.659.731l-1.123,1.011a.488.488,0,0,1-.33.127",
    transform: "translate(-145.974 -58.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309025",
    "data-name": "Path 309025",
    d: "M168.462,64.461H155.773a.491.491,0,0,1,0-.983h12.689a.491.491,0,1,1,0,.983",
    transform: "translate(-149.761 -55.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309026",
    "data-name": "Path 309026",
    d: "M169.209,66.424H155.774a.491.491,0,1,1,0-.983h13.434a.491.491,0,0,1,0,.983",
    transform: "translate(-149.762 -52.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309027",
    "data-name": "Path 309027",
    d: "M169.457,68.271H155.772a.491.491,0,1,1,0-.983h13.684a.491.491,0,1,1,0,.983",
    transform: "translate(-149.762 -50.813)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88238",
    "data-name": "Group 88238",
    transform: "translate(389.447 128.531)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88237",
    "data-name": "Group 88237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88236",
    "data-name": "Group 88236",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309028",
    "data-name": "Path 309028",
    d: "M181.522,82.414a.489.489,0,0,1-.491-.491V75.536c0-3.269-.31-14.777-.312-14.891a.491.491,0,0,1,.461-.5c.078-.006,7.913-.476,14.423-.237,6.467.233,9.915,0,9.95,0a.518.518,0,0,1,.362.123.5.5,0,0,1,.164.347l.937,21.291a.493.493,0,0,1-.491.515H195.273c-4.319,0-13.645.233-13.738.235Zm.192-21.319c.058,2.222.3,11.542.3,14.441v5.883c2.011-.047,9.51-.224,13.26-.224h10.738l-.894-20.283c-1.185.054-4.444.159-9.549-.026-5.547-.2-12.064.112-13.854.209",
    transform: "translate(-180.718 -59.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309029",
    "data-name": "Path 309029",
    d: "M190.235,61.8a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-173.504 -59.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309030",
    "data-name": "Path 309030",
    d: "M191.121,61.279a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-172.481 -59.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309031",
    "data-name": "Path 309031",
    d: "M187.051,62.942a.483.483,0,0,1-.364-.164.489.489,0,0,1,.034-.694l1.123-1.011a.492.492,0,0,1,.659.731l-1.123,1.011a.489.489,0,0,1-.33.127",
    transform: "translate(-173.972 -58.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309032",
    "data-name": "Path 309032",
    d: "M196.46,64.461H183.771a.491.491,0,0,1,0-.983H196.46a.491.491,0,0,1,0,.983",
    transform: "translate(-177.759 -55.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309033",
    "data-name": "Path 309033",
    d: "M197.207,66.424H183.772a.491.491,0,1,1,0-.983h13.434a.491.491,0,0,1,0,.983",
    transform: "translate(-177.76 -52.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309034",
    "data-name": "Path 309034",
    d: "M197.456,68.271H183.771a.491.491,0,0,1,0-.983h13.684a.491.491,0,0,1,0,.983",
    transform: "translate(-177.759 -50.813)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88241",
    "data-name": "Group 88241",
    transform: "translate(400.449 77.968)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88240",
    "data-name": "Group 88240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88239",
    "data-name": "Group 88239",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309035",
    "data-name": "Path 309035",
    d: "M186.627,58.952a.493.493,0,0,1-.491-.491V52.073c0-3.269-.31-14.777-.312-14.893a.49.49,0,0,1,.461-.5c.078-.009,7.913-.476,14.423-.237,6.467.233,9.915,0,9.95,0a.518.518,0,0,1,.362.123.5.5,0,0,1,.164.347l.937,21.291a.493.493,0,0,1-.491.515H200.378c-4.319,0-13.645.233-13.738.235Zm.192-21.322c.058,2.224.3,11.544.3,14.443v5.881c2.011-.045,9.512-.222,13.26-.222h10.738l-.894-20.283c-1.185.052-4.444.159-9.549-.026-5.547-.2-12.064.11-13.854.207",
    transform: "translate(-185.823 -35.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309036",
    "data-name": "Path 309036",
    d: "M195.34,38.337a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-178.609 -35.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309037",
    "data-name": "Path 309037",
    d: "M196.226,37.816a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-177.586 -36.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309038",
    "data-name": "Path 309038",
    d: "M192.156,39.479a.483.483,0,0,1-.364-.164.489.489,0,0,1,.034-.694l1.123-1.011a.492.492,0,0,1,.659.731l-1.123,1.011a.488.488,0,0,1-.33.127",
    transform: "translate(-179.077 -34.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309039",
    "data-name": "Path 309039",
    d: "M201.565,41H188.876a.491.491,0,0,1,0-.983h12.689a.491.491,0,0,1,0,.983",
    transform: "translate(-182.864 -31.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309040",
    "data-name": "Path 309040",
    d: "M202.312,42.96H188.877a.491.491,0,1,1,0-.983h13.434a.491.491,0,0,1,0,.983",
    transform: "translate(-182.865 -29.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309041",
    "data-name": "Path 309041",
    d: "M202.56,44.808H188.875a.491.491,0,1,1,0-.983H202.56a.491.491,0,1,1,0,.983",
    transform: "translate(-182.865 -27.35)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88244",
    "data-name": "Group 88244",
    transform: "translate(325.028 72.72)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88243",
    "data-name": "Group 88243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88242",
    "data-name": "Group 88242",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309042",
    "data-name": "Path 309042",
    d: "M151.629,56.516a.489.489,0,0,1-.491-.491V49.638c0-3.269-.31-14.777-.312-14.891a.491.491,0,0,1,.461-.5c.078-.006,7.913-.476,14.423-.237,6.467.233,9.915,0,9.95,0a.51.51,0,0,1,.362.125.491.491,0,0,1,.164.345l.937,21.291a.493.493,0,0,1-.491.515H165.38c-4.319,0-13.645.233-13.738.235Zm.192-21.319c.058,2.222.3,11.542.3,14.441v5.883c2.011-.047,9.51-.224,13.26-.224h10.738l-.894-20.283c-1.185.056-4.444.159-9.549-.026-5.547-.2-12.064.112-13.854.209",
    transform: "translate(-150.825 -33.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309043",
    "data-name": "Path 309043",
    d: "M160.342,35.9a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-143.611 -33.143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309044",
    "data-name": "Path 309044",
    d: "M161.228,35.381a1.636,1.636,0,1,0-1.636,1.636,1.636,1.636,0,0,0,1.636-1.636",
    transform: "translate(-142.588 -33.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309045",
    "data-name": "Path 309045",
    d: "M157.158,37.044a.483.483,0,0,1-.364-.164.489.489,0,0,1,.035-.694l1.123-1.011a.492.492,0,0,1,.659.731l-1.123,1.011a.488.488,0,0,1-.33.127",
    transform: "translate(-144.079 -32.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309046",
    "data-name": "Path 309046",
    d: "M166.568,38.563H153.879a.491.491,0,1,1,0-.983h12.689a.491.491,0,0,1,0,.983",
    transform: "translate(-147.867 -29.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309047",
    "data-name": "Path 309047",
    d: "M167.314,40.526H153.879a.491.491,0,1,1,0-.983h13.434a.491.491,0,0,1,0,.983",
    transform: "translate(-147.867 -27.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309048",
    "data-name": "Path 309048",
    d: "M167.562,42.373H153.877a.491.491,0,0,1,0-.983h13.684a.491.491,0,0,1,0,.983",
    transform: "translate(-147.867 -24.915)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88247",
    "data-name": "Group 88247",
    transform: "translate(36.727 94.589)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88246",
    "data-name": "Group 88246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88245",
    "data-name": "Group 88245",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25753",
    "data-name": "Rectangle 25753",
    width: 12.891,
    height: 12.891,
    transform: "translate(0.492 1.146)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11111",
    "data-name": "Line 11111",
    x2: 37.6,
    transform: "translate(19.292 7.592)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25754",
    "data-name": "Rectangle 25754",
    width: 12.891,
    height: 12.891,
    transform: "translate(0.492 20.822)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11112",
    "data-name": "Line 11112",
    x2: 37.6,
    transform: "translate(19.292 27.267)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25755",
    "data-name": "Rectangle 25755",
    width: 12.891,
    height: 12.891,
    transform: "translate(0.492 40.497)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11113",
    "data-name": "Line 11113",
    x2: 37.6,
    transform: "translate(19.292 46.943)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25756",
    "data-name": "Rectangle 25756",
    width: 12.891,
    height: 12.891,
    transform: "translate(0.492 60.172)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11114",
    "data-name": "Line 11114",
    x2: 37.6,
    transform: "translate(19.292 66.618)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309049",
    "data-name": "Path 309049",
    d: "M18.792,66.62l1.968,5.247,13.773-9.182",
    transform: "translate(-15.021 -22.188)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309050",
    "data-name": "Path 309050",
    d: "M18.792,48.056,20.76,53.3l13.773-9.182",
    transform: "translate(-15.021 -43.63)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88250",
    "data-name": "Group 88250",
    transform: "translate(100.998 190.34)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88249",
    "data-name": "Group 88249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88248",
    "data-name": "Group 88248",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25758",
    "data-name": "Rectangle 25758",
    width: 8.814,
    height: 8.814,
    transform: "translate(0.491 0.94)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11115",
    "data-name": "Line 11115",
    x2: 25.709,
    transform: "translate(13.346 5.347)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25759",
    "data-name": "Rectangle 25759",
    width: 8.814,
    height: 8.814,
    transform: "translate(0.491 14.391)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11116",
    "data-name": "Line 11116",
    x2: 25.709,
    transform: "translate(13.346 18.799)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25760",
    "data-name": "Rectangle 25760",
    width: 8.814,
    height: 8.814,
    transform: "translate(0.491 27.845)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11117",
    "data-name": "Line 11117",
    x2: 25.709,
    transform: "translate(13.346 32.251)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25761",
    "data-name": "Rectangle 25761",
    width: 8.814,
    height: 8.814,
    transform: "translate(0.491 41.296)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11118",
    "data-name": "Line 11118",
    x2: 25.709,
    transform: "translate(13.346 45.703)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309051",
    "data-name": "Path 309051",
    d: "M48.136,103.935l1.345,3.588,9.417-6.278",
    transform: "translate(-45.402 -73.401)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309052",
    "data-name": "Path 309052",
    d: "M48.136,91.243l1.345,3.588L58.9,88.553",
    transform: "translate(-45.402 -88.061)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88253",
    "data-name": "Group 88253",
    transform: "translate(113.629 41.197)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88252",
    "data-name": "Group 88252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88251",
    "data-name": "Group 88251",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309053",
    "data-name": "Path 309053",
    d: "M87.983,39.348V34.37l-5.521-.858a12.406,12.406,0,0,0-1.142-2.769l3.293-4.508-3.519-3.519-4.508,3.293a12.407,12.407,0,0,0-2.769-1.142l-.858-5.521H67.981l-.858,5.521a12.407,12.407,0,0,0-2.769,1.142l-4.508-3.293-3.519,3.519,3.293,4.508a12.407,12.407,0,0,0-1.142,2.769l-5.521.858v4.978l5.521.858a12.407,12.407,0,0,0,1.142,2.769l-3.293,4.508L59.846,51l4.508-3.293a12.407,12.407,0,0,0,2.769,1.142l.858,5.521h4.978l.858-5.521a12.408,12.408,0,0,0,2.769-1.142L81.094,51l3.519-3.519L81.32,42.975a12.406,12.406,0,0,0,1.142-2.769ZM70.47,44.729a7.87,7.87,0,1,1,7.87-7.87A7.87,7.87,0,0,1,70.47,44.729Z",
    transform: "translate(-52.465 -18.854)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88256",
    "data-name": "Group 88256",
    transform: "translate(92.642 63.034)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88255",
    "data-name": "Group 88255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88254",
    "data-name": "Group 88254",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309054",
    "data-name": "Path 309054",
    d: "M66.659,42.863V39.531l-3.7-.573A8.15,8.15,0,0,0,62.2,37.1l2.2-3.017-2.355-2.355-3.017,2.2a8.149,8.149,0,0,0-1.853-.765L56.6,29.478H53.272L52.7,33.172a8.149,8.149,0,0,0-1.853.765l-3.017-2.2-2.355,2.355,2.2,3.017a8.149,8.149,0,0,0-.765,1.853l-3.7.573v3.332l3.7.575a8.173,8.173,0,0,0,.765,1.851l-2.2,3.017,2.355,2.355,3.017-2.2a8.149,8.149,0,0,0,1.853.765l.573,3.7H56.6l.573-3.7a8.149,8.149,0,0,0,1.853-.765l3.017,2.2L64.4,48.306l-2.2-3.017a8.174,8.174,0,0,0,.765-1.851Zm-11.721,3.6A5.267,5.267,0,1,1,60.2,41.2,5.266,5.266,0,0,1,54.938,46.464Z",
    transform: "translate(-42.727 -28.987)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88259",
    "data-name": "Group 88259",
    transform: "translate(287.393 278.124)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88258",
    "data-name": "Group 88258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88257",
    "data-name": "Group 88257",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309055",
    "data-name": "Path 309055",
    d: "M137.7,135.5l-2.644,4.215,4.222,3.661a12.331,12.331,0,0,0-.5,2.952l-5.187,2.069,1.112,4.853,5.569-.4a12.431,12.431,0,0,0,1.739,2.439l-2.2,5.133,4.215,2.644,3.661-4.22a12.33,12.33,0,0,0,2.952.5l2.069,5.185,4.853-1.112-.4-5.569a12.421,12.421,0,0,0,2.439-1.737l5.133,2.2,2.644-4.217-4.219-3.659a12.46,12.46,0,0,0,.5-2.954l5.185-2.069-1.112-4.851-5.569.4a12.28,12.28,0,0,0-1.739-2.439l2.207-5.133-4.217-2.646-3.661,4.222a12.315,12.315,0,0,0-2.952-.5l-2.069-5.187-4.851,1.112.394,5.571a12.4,12.4,0,0,0-2.439,1.737Zm17.7,4.745a7.87,7.87,0,1,1-10.848,2.487A7.87,7.87,0,0,1,155.4,140.248Z",
    transform: "translate(-133.098 -128.797)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88262",
    "data-name": "Group 88262",
    transform: "translate(324.435 284.593)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88261",
    "data-name": "Group 88261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88260",
    "data-name": "Group 88260",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309056",
    "data-name": "Path 309056",
    d: "M153.53,136.447l-1.769,2.823,2.823,2.448a8.342,8.342,0,0,0-.336,1.976l-3.47,1.386.743,3.245,3.726-.263a8.248,8.248,0,0,0,1.164,1.631l-1.476,3.435,2.823,1.769,2.448-2.823a8.341,8.341,0,0,0,1.978.336l1.384,3.47,3.248-.743-.265-3.726a8.249,8.249,0,0,0,1.631-1.164l3.435,1.476,1.771-2.823-2.825-2.448a8.339,8.339,0,0,0,.336-1.978l3.47-1.384-.743-3.248-3.726.265a8.252,8.252,0,0,0-1.164-1.631l1.476-3.435-2.823-1.771-2.448,2.825a8.341,8.341,0,0,0-1.978-.336l-1.384-3.47-3.248.743.265,3.726a8.251,8.251,0,0,0-1.631,1.164Zm11.842,3.176a5.267,5.267,0,1,1-7.26,1.664A5.268,5.268,0,0,1,165.372,139.623Z",
    transform: "translate(-150.287 -131.798)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25767",
    "data-name": "Rectangle 25767",
    width: 83.013,
    height: 45.994,
    transform: "translate(2.685 222.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25768",
    "data-name": "Rectangle 25768",
    width: 83.013,
    height: 45.994,
    transform: "translate(2.685 222.185)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25769",
    "data-name": "Rectangle 25769",
    width: 83.013,
    height: 45.994,
    transform: "translate(5.209 222.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25770",
    "data-name": "Rectangle 25770",
    width: 83.013,
    height: 45.994,
    transform: "translate(5.209 222.185)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309057",
    "data-name": "Path 309057",
    d: "M29.218,106.4,15.443,130.258h27.55Z",
    transform: "translate(17.836 122.892)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309058",
    "data-name": "Path 309058",
    d: "M29.218,106.4,15.443,130.258h27.55Z",
    transform: "translate(17.836 122.892)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25771",
    "data-name": "Rectangle 25771",
    width: 83.013,
    height: 45.994,
    transform: "translate(369.141 304.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25772",
    "data-name": "Rectangle 25772",
    width: 83.013,
    height: 45.994,
    transform: "translate(369.141 304.818)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25773",
    "data-name": "Rectangle 25773",
    width: 83.013,
    height: 45.994,
    transform: "translate(366.617 304.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25774",
    "data-name": "Rectangle 25774",
    width: 83.013,
    height: 45.994,
    transform: "translate(366.617 304.818)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309059",
    "data-name": "Path 309059",
    d: "M196.328,145.5l4.4,8.917,9.842,1.431-7.12,6.941,1.681,9.8-8.8-4.629-8.8,4.629,1.681-9.8-7.12-6.941,9.842-1.431Z",
    transform: "translate(210.309 168.055)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309060",
    "data-name": "Path 309060",
    d: "M196.328,145.5l4.4,8.917,9.842,1.431-7.12,6.941,1.681,9.8-8.8-4.629-8.8,4.629,1.681-9.8-7.12-6.941,9.842-1.431Z",
    transform: "translate(210.309 168.055)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309061",
    "data-name": "Path 309061",
    d: "M126.173,103.96s-32.092,8.93-33.489,12-19.535,36-19.535,36L89.335,175.4l13.954-18.141,5.023,42.977s-6.14,10.047-3.907,14.512a13.666,13.666,0,0,0,6.14,6.14h73.117a16.592,16.592,0,0,0,3.349-12.279c-1.116-6.976-3.071-15.628-3.071-15.628l-.278-24.558,8.372-25.675,41.023-.278-6.976-28.746s-28.465-6.14-30.42-7.256S183.94,103.4,179.2,103.4H165.8l-37.118-.28Z",
    transform: "translate(84.487 119.106)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309062",
    "data-name": "Path 309062",
    d: "M126.173,103.96s-32.092,8.93-33.489,12-19.535,36-19.535,36L89.335,175.4l13.954-18.141,5.023,42.977s-6.14,10.047-3.907,14.512a13.666,13.666,0,0,0,6.14,6.14h73.117a16.592,16.592,0,0,0,3.349-12.279c-1.116-6.976-3.071-15.628-3.071-15.628l-.278-24.558,8.372-25.675,41.023-.278-6.976-28.746s-28.465-6.14-30.42-7.256S183.94,103.4,179.2,103.4H165.8l-37.118-.28Z",
    transform: "translate(84.487 119.106)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309063",
    "data-name": "Path 309063",
    d: "M87.155,117.558l5.963,23.031L81.955,120.5",
    transform: "translate(94.658 135.78)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11119",
    "data-name": "Line 11119",
    x2: 0.978,
    y2: 3.776,
    transform: "translate(179.684 245.113)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11120",
    "data-name": "Line 11120",
    x1: 4.715,
    y1: 2.633,
    transform: "translate(166.288 264.369)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11121",
    "data-name": "Line 11121",
    x1: 14.253,
    y1: 7.958,
    transform: "translate(173.524 268.411)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309064",
    "data-name": "Path 309064",
    d: "M134.456,110.893l-6.14,22.884L140.6,110.893",
    transform: "translate(148.205 128.081)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11122",
    "data-name": "Line 11122",
    y1: 2.302,
    x2: 3.769,
    transform: "translate(299.262 245.672)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11123",
    "data-name": "Line 11123",
    y1: 11.387,
    x2: 18.649,
    transform: "translate(276.521 250.47)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11124",
    "data-name": "Line 11124",
    y1: 2.681,
    x2: 3.439,
    transform: "translate(246.013 295.068)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11125",
    "data-name": "Line 11125",
    y1: 27.894,
    x2: 35.762,
    transform: "translate(207.591 299.824)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11126",
    "data-name": "Line 11126",
    x1: 20.093,
    y2: 14.232,
    transform: "translate(207.59 308.462)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309065",
    "data-name": "Path 309065",
    d: "M101.76,94.187l-1.674,22.046,16.464,18.419,14.234-17.58L126.318,95.3Z",
    transform: "translate(115.599 108.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309066",
    "data-name": "Path 309066",
    d: "M101.76,94.187l-1.674,22.046,16.464,18.419,14.234-17.58L126.318,95.3Z",
    transform: "translate(115.599 108.786)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309067",
    "data-name": "Path 309067",
    d: "M125.647,95.3l-24.558-1.116-.422,5.558c3.672,4.254,11.016,13.577,13.99,14.32,2.491.623,8.9-6.525,12.443-11.678Z",
    transform: "translate(116.269 108.786)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309068",
    "data-name": "Path 309068",
    d: "M125.647,95.3l-24.558-1.116-.422,5.558c3.672,4.254,11.016,13.577,13.99,14.32,2.491.623,8.9-6.525,12.443-11.678Z",
    transform: "translate(116.269 108.786)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309069",
    "data-name": "Path 309069",
    d: "M101.483,98.2l15.348,19.535-10.6,20.371-9.766-28.185Z",
    transform: "translate(111.41 113.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309070",
    "data-name": "Path 309070",
    d: "M101.483,98.2l15.348,19.535-10.6,20.371-9.766-28.185Z",
    transform: "translate(111.41 113.423)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309071",
    "data-name": "Path 309071",
    d: "M123.721,98.2l-15.348,19.535,10.6,20.371,9.766-28.185Z",
    transform: "translate(125.172 113.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309072",
    "data-name": "Path 309072",
    d: "M123.721,98.2l-15.348,19.535,10.6,20.371,9.766-28.185Z",
    transform: "translate(125.172 113.423)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309073",
    "data-name": "Path 309073",
    d: "M99.765,82.626s-3.069-6.418-5.859-1.394,6.14,15.068,7.254,15.068-1.394-13.673-1.394-13.673",
    transform: "translate(107.84 91.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309074",
    "data-name": "Path 309074",
    d: "M99.765,82.626s-3.069-6.418-5.859-1.394,6.14,15.068,7.254,15.068S99.765,82.626,99.765,82.626Z",
    transform: "translate(107.84 91.604)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309075",
    "data-name": "Path 309075",
    d: "M117.828,82.626s3.069-6.418,5.859-1.394S117.55,96.3,116.433,96.3s1.394-13.673,1.394-13.673",
    transform: "translate(134.15 91.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309076",
    "data-name": "Path 309076",
    d: "M117.828,82.626s3.069-6.418,5.859-1.394S117.55,96.3,116.433,96.3,117.828,82.626,117.828,82.626Z",
    transform: "translate(134.15 91.604)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309077",
    "data-name": "Path 309077",
    d: "M95.442,71.007c.22,4.571,1.847,36.8,4.439,43.535,2.791,7.256,15.628,18.977,21.768,18.419s17.022-14.234,18.419-19.257c1.254-4.515,2.282-36.323,2.478-42.7Z",
    transform: "translate(110.236 82.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309078",
    "data-name": "Path 309078",
    d: "M95.442,71.007c.22,4.571,1.847,36.8,4.439,43.535,2.791,7.256,15.628,18.977,21.768,18.419s17.022-14.234,18.419-19.257c1.254-4.515,2.282-36.323,2.478-42.7Z",
    transform: "translate(110.236 82.013)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309079",
    "data-name": "Path 309079",
    d: "M98.8,83.071s3.907,4.185,11.163-.28",
    transform: "translate(114.111 95.624)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309080",
    "data-name": "Path 309080",
    d: "M120.838,83.071s-3.907,4.185-11.163-.28",
    transform: "translate(126.675 95.624)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309081",
    "data-name": "Path 309081",
    d: "M105.272,87.971s2.791,5.3,8.93,0",
    transform: "translate(121.589 101.607)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11127",
    "data-name": "Line 11127",
    x2: 5.023,
    transform: "translate(228.535 199.067)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309082",
    "data-name": "Path 309082",
    d: "M98.02,79.936s1.952-1.95,12-.278",
    transform: "translate(113.213 91.223)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309083",
    "data-name": "Path 309083",
    d: "M121.415,79.936s-1.952-1.95-12-.278",
    transform: "translate(126.375 91.223)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.913
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309084",
    "data-name": "Path 309084",
    d: "M147.223,141.765s30.14-63.348,33.209-63.629,6.7,3.907,5.582,9.488-16.464,59.163-19.813,70.326-7.814,15.628-11.443,14.232-7.534-30.418-7.534-30.418",
    transform: "translate(170.043 90.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309085",
    "data-name": "Path 309085",
    d: "M147.223,141.765s30.14-63.348,33.209-63.629,6.7,3.907,5.582,9.488-16.464,59.163-19.813,70.326-7.814,15.628-11.443,14.232S147.223,141.765,147.223,141.765Z",
    transform: "translate(170.043 90.232)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309086",
    "data-name": "Path 309086",
    d: "M67.888,128.3s15.413,35,18.988,34.379,14.195-11.24,14.686-13.307-6.6-13.585-13.749-18.861-9.45-7.142-10.551-6.952-7.592,3.582-9.374,4.741",
    transform: "translate(78.411 142.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309087",
    "data-name": "Path 309087",
    d: "M67.888,128.3s15.413,35,18.988,34.379,14.195-11.24,14.686-13.307-6.6-13.585-13.749-18.861-9.45-7.142-10.551-6.952S69.67,127.146,67.888,128.3Z",
    transform: "translate(78.411 142.701)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309088",
    "data-name": "Path 309088",
    d: "M143.66,107.748s-2.791,18.7-.278,26.233,5.023,8.65,9.208,8.93,10.325-.838,11.441-3.629-8.93-30.14-10.047-32.092-6.7-1.674-10.325.558",
    transform: "translate(164.395 122.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309089",
    "data-name": "Path 309089",
    d: "M143.66,107.748s-2.791,18.7-.278,26.233,5.023,8.65,9.208,8.93,10.325-.838,11.441-3.629-8.93-30.14-10.047-32.092S147.289,105.515,143.66,107.748Z",
    transform: "translate(164.395 122.296)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309090",
    "data-name": "Path 309090",
    d: "M50.131,129.789a66.112,66.112,0,0,0-6.954-4.176s-4.459-1.209-5.448-5.286,4.737-5.353,4.737-5.353c3.67-.069,66.1,26.78,66.1,26.78,10.583,12.044,12.465,26.162,12.8,28.088a2.534,2.534,0,0,1-2.319,2.95c-1.1.192-19.85-8.135-25.444-11.167-11.878-6.439-39.969-29.61-39.969-29.61Z",
    transform: "translate(43.444 132.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309091",
    "data-name": "Path 309091",
    d: "M50.131,129.789a66.112,66.112,0,0,0-6.954-4.176s-4.459-1.209-5.448-5.286,4.737-5.353,4.737-5.353c3.67-.069,66.1,26.78,66.1,26.78,10.583,12.044,12.465,26.162,12.8,28.088a2.534,2.534,0,0,1-2.319,2.95c-1.1.192-19.85-8.135-25.444-11.167-11.878-6.439-39.969-29.61-39.969-29.61Z",
    transform: "translate(43.444 132.794)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309092",
    "data-name": "Path 309092",
    d: "M36.205,126.084s-2.668,4.1-5.476,5.887-6.506,2.946-5.323,3.78,2.577,1.373,5.474.091,6.3-2.651,6.3-2.651,3.021-8.06-.972-7.107",
    transform: "translate(29.083 145.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309093",
    "data-name": "Path 309093",
    d: "M36.205,126.084s-2.668,4.1-5.476,5.887-6.506,2.946-5.323,3.78,2.577,1.373,5.474.091,6.3-2.651,6.3-2.651S40.2,125.131,36.205,126.084Z",
    transform: "translate(29.083 145.537)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309094",
    "data-name": "Path 309094",
    d: "M36.186,127.4s-2.517,7.971-5.7,10.6-7.758,4.724-4.808,5.252,4.793-.832,8.777-3.34,5.189-4.538,4.612-9.376-1.215-5.506-2.883-3.138",
    transform: "translate(28.563 145.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309095",
    "data-name": "Path 309095",
    d: "M36.186,127.4s-2.517,7.971-5.7,10.6-7.758,4.724-4.808,5.252,4.793-.832,8.777-3.34,5.189-4.538,4.612-9.376S37.854,125.029,36.186,127.4Z",
    transform: "translate(28.563 145.615)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309096",
    "data-name": "Path 309096",
    d: "M33.7,125.705s-.235,9.137-.84,13.139-8.135,11.544-4.976,11.777,8.745-8.012,10.032-11.094,2.207-3.76,1.22-6.448-4.655-10.368-5.435-7.374",
    transform: "translate(31.32 144.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309097",
    "data-name": "Path 309097",
    d: "M33.7,125.705s-.235,9.137-.84,13.139-8.135,11.544-4.976,11.777,8.745-8.012,10.032-11.094,2.207-3.76,1.22-6.448S34.485,122.712,33.7,125.705Z",
    transform: "translate(31.32 144.403)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309098",
    "data-name": "Path 309098",
    d: "M58.418,143.714a13.472,13.472,0,1,1-13.471-13.471,13.47,13.47,0,0,1,13.471,13.471",
    transform: "translate(36.352 150.431)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309099",
    "data-name": "Path 309099",
    d: "M58.418,143.714a13.472,13.472,0,1,1-13.471-13.471A13.47,13.47,0,0,1,58.418,143.714Z",
    transform: "translate(36.352 150.431)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309100",
    "data-name": "Path 309100",
    d: "M57.877,117.448s-8.323-4.534-12.217-1.521S33.015,132.932,30.127,135.77s2.506,9.96,4.357,16.137.366,11.111,3.558,10.038,1.866-4.222,2.08-10.495-2.308-11.814-2.187-12.615,6.409-5.008,10.5-3.9,6.129,3.877,5.9,7.034-2.573,12.141-1.379,14.533,3.388,3.049,4.707-1.336,4.844-12.533,5.581-15.779-6.471-17.85-6.471-17.85",
    transform: "translate(33.835 132.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309101",
    "data-name": "Path 309101",
    d: "M57.877,117.448s-8.323-4.534-12.217-1.521S33.015,132.932,30.127,135.77s2.506,9.96,4.357,16.137.366,11.111,3.558,10.038,1.866-4.222,2.08-10.495-2.308-11.814-2.187-12.615,6.409-5.008,10.5-3.9,6.129,3.877,5.9,7.034-2.573,12.141-1.379,14.533,3.388,3.049,4.707-1.336,4.844-12.533,5.581-15.779-6.471-17.85-6.471-17.85",
    transform: "translate(33.835 132.702)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309102",
    "data-name": "Path 309102",
    d: "M37.911,155.2a13.472,13.472,0,0,1,6.562-24.953",
    transform: "translate(36.352 150.435)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309103",
    "data-name": "Path 309103",
    d: "M37.911,155.2a13.472,13.472,0,0,1,6.562-24.953",
    transform: "translate(36.352 150.435)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309104",
    "data-name": "Path 309104",
    d: "M177.394,82.794S181.68,85.149,185,85.4s7.127-.474,6.476.821-1.623,2.427-4.782,2.664-6.8.636-6.8.636-6.467-5.681-2.5-6.726",
    transform: "translate(203.401 95.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309105",
    "data-name": "Path 309105",
    d: "M177.394,82.794S181.68,85.149,185,85.4s7.127-.474,6.476.821-1.623,2.427-4.782,2.664-6.8.636-6.8.636S173.424,83.839,177.394,82.794Z",
    transform: "translate(203.401 95.627)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309106",
    "data-name": "Path 309106",
    d: "M178.408,83.538s5.982,5.84,10.029,6.659,9.068.5,6.715,2.36-4.618,1.53-9.314,1.2-6.717-1.552-8.491-6.09-1.528-5.426,1.06-4.127",
    transform: "translate(203.518 95.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309107",
    "data-name": "Path 309107",
    d: "M178.408,83.538s5.982,5.84,10.029,6.659,9.068.5,6.715,2.36-4.618,1.53-9.314,1.2-6.717-1.552-8.491-6.09S175.82,82.239,178.408,83.538Z",
    transform: "translate(203.518 95.857)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309108",
    "data-name": "Path 309108",
    d: "M177.351,82.322s4.519,7.943,6.943,11.187,12.62,6.34,9.945,8.034-11.493-2.935-14.081-5.045-3.72-2.274-4.12-5.109-.789-11.337,1.312-9.066",
    transform: "translate(202.961 94.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309109",
    "data-name": "Path 309109",
    d: "M177.351,82.322s4.519,7.943,6.943,11.187,12.62,6.34,9.945,8.034-11.493-2.935-14.081-5.045-3.72-2.274-4.12-5.109S175.25,80.051,177.351,82.322Z",
    transform: "translate(202.961 94.642)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25775",
    "data-name": "Rectangle 25775",
    width: 20.766,
    height: 20.766,
    transform: "translate(364.41 196.639)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25776",
    "data-name": "Rectangle 25776",
    width: 20.766,
    height: 20.766,
    transform: "translate(364.41 196.639)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309110",
    "data-name": "Path 309110",
    d: "M161.19,83.639s5.2-7.926,10.053-7.107,19.175,9.023,23.059,10.163,2.493,9.965,3.778,16.283,4.92,9.969,1.6,10.529-3.638-2.84-6.786-8.271-3.543-11.506-4.026-12.154-8.014-1.39-11.1,1.519-3.575,6.308-1.879,8.984,8,9.488,8.075,12.161-1.547,4.288-4.78,1.043S169,108.027,166.819,105.512s-2.72-18.792-2.72-18.792",
    transform: "translate(186.174 88.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309111",
    "data-name": "Path 309111",
    d: "M161.19,83.639s5.2-7.926,10.053-7.107,19.175,9.023,23.059,10.163,2.493,9.965,3.778,16.283,4.92,9.969,1.6,10.529-3.638-2.84-6.786-8.271-3.543-11.506-4.026-12.154-8.014-1.39-11.1,1.519-3.575,6.308-1.879,8.984,8,9.488,8.075,12.161-1.547,4.288-4.78,1.043S169,108.027,166.819,105.512s-2.72-18.792-2.72-18.792",
    transform: "translate(186.174 88.326)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309112",
    "data-name": "Path 309112",
    d: "M173.939,91.249h10.338v10.491",
    transform: "translate(200.899 105.392)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309113",
    "data-name": "Path 309113",
    d: "M173.939,91.249h10.338v10.491",
    transform: "translate(200.899 105.392)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309114",
    "data-name": "Path 309114",
    d: "M121.444,157.771,116.5,176.224l-52.787-2.28s31.9,26.2,47.47,31.521,36.835,11.012,54.683,9.493,35.318-4.937,53.166-13.671,28.483-25.823,28.483-25.823H197.005l-2.444-17.693Z",
    transform: "translate(73.587 182.225)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309115",
    "data-name": "Path 309115",
    d: "M121.444,157.771,116.5,176.224l-52.787-2.28s31.9,26.2,47.47,31.521,36.835,11.012,54.683,9.493,35.318-4.937,53.166-13.671,28.483-25.823,28.483-25.823H197.005l-2.444-17.693Z",
    transform: "translate(73.587 182.225)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309116",
    "data-name": "Path 309116",
    d: "M128.029,178.533s12.143.894,20.884-1.362,15.05,2.058,15.85,10.217-3.289,15.647-14.132,16.466-26.353-6.286-26.353-6.286-4.256-10.93,3.752-19.035",
    transform: "translate(142.236 203.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309117",
    "data-name": "Path 309117",
    d: "M128.029,178.533s12.143.894,20.884-1.362,15.05,2.058,15.85,10.217-3.289,15.647-14.132,16.466-26.353-6.286-26.353-6.286S120.021,186.638,128.029,178.533Z",
    transform: "translate(142.236 203.945)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309118",
    "data-name": "Path 309118",
    d: "M132.229,202.52s10.047,2.411,14.872-2.532,5.8-12.074,4.284-17.675a8.013,8.013,0,0,0-5.959-5.734c6.293.078,10.594,4.168,11.247,10.807.8,8.159-3.289,15.65-14.132,16.466a40.79,40.79,0,0,1-12.389-1.448Z",
    transform: "translate(150.326 203.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309119",
    "data-name": "Path 309119",
    d: "M132.229,202.52s10.047,2.411,14.872-2.532,5.8-12.074,4.284-17.675a8.013,8.013,0,0,0-5.959-5.734c6.293.078,10.594,4.168,11.247,10.807.8,8.159-3.289,15.65-14.132,16.466a40.79,40.79,0,0,1-12.389-1.448Z",
    transform: "translate(150.326 203.948)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309120",
    "data-name": "Path 309120",
    d: "M125.363,179.052s6.064,2.7,11.066,2.552,7.09,4.291,3.969,7.392-16.113-.545-17.251-1.323-.8-6.331,2.215-8.62",
    transform: "translate(141.541 206.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309121",
    "data-name": "Path 309121",
    d: "M125.363,179.052s6.064,2.7,11.066,2.552,7.09,4.291,3.969,7.392-16.113-.545-17.251-1.323S122.352,181.341,125.363,179.052Z",
    transform: "translate(141.541 206.805)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309122",
    "data-name": "Path 309122",
    d: "M144.051,183.172a384.236,384.236,0,0,1-55.019-29.545c-9.047-5.961-18.093-8.224-25.907-1.849s-7.4,20.354-1.028,27.552,26.112,14.391,44.824,22.205,56.541,16.859,67.439,19.738,13.982,4.73,16.654,7.2,9.331,2.161,9.331,2.161-.08-8.329,1.771-12.236,3.084-6.579,3.084-6.579-3.289-2.467-6.372-4.728-3.907-.616-10.281-4.73c-7.045-4.543-15.68-7.271-23.427-10.342-7-2.776-14.048-5.719-21.067-8.842",
    transform: "translate(66.169 170.884)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309123",
    "data-name": "Path 309123",
    d: "M144.051,183.172a384.236,384.236,0,0,1-55.019-29.545c-9.047-5.961-18.093-8.224-25.907-1.849s-7.4,20.354-1.028,27.552,26.112,14.391,44.824,22.205,56.541,16.859,67.439,19.738,13.982,4.73,16.654,7.2,9.331,2.161,9.331,2.161-.08-8.329,1.771-12.236,3.084-6.579,3.084-6.579-3.289-2.467-6.372-4.728-3.907-.616-10.281-4.73c-7.045-4.543-15.68-7.271-23.427-10.342C158.117,189.238,151.07,186.295,144.051,183.172Z",
    transform: "translate(66.169 170.884)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309124",
    "data-name": "Path 309124",
    d: "M102.473,181.439s-12.152-.758-20.507-4.176-15.191,0-17.089,7.974,1.14,15.949,11.773,18.229,26.963-2.659,26.963-2.659,5.7-10.253-1.14-19.367",
    transform: "translate(74.321 203.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309125",
    "data-name": "Path 309125",
    d: "M102.473,181.439s-12.152-.758-20.507-4.176-15.191,0-17.089,7.974,1.14,15.949,11.773,18.229,26.963-2.659,26.963-2.659S109.309,190.552,102.473,181.439Z",
    transform: "translate(74.321 203.214)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309126",
    "data-name": "Path 309126",
    d: "M87.047,203.542s-10.279,1.028-14.393-4.523-4.112-12.747-1.849-18.093a8.018,8.018,0,0,1,6.68-4.875c-6.245-.776-11.062,2.7-12.607,9.187-1.9,7.974,1.138,15.949,11.773,18.227a40.717,40.717,0,0,0,12.469.244Z",
    transform: "translate(74.322 203.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309127",
    "data-name": "Path 309127",
    d: "M87.047,203.542s-10.279,1.028-14.393-4.523-4.112-12.747-1.849-18.093a8.018,8.018,0,0,1,6.68-4.875c-6.245-.776-11.062,2.7-12.607,9.187-1.9,7.974,1.138,15.949,11.773,18.227a40.717,40.717,0,0,0,12.469.244Z",
    transform: "translate(74.322 203.214)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309128",
    "data-name": "Path 309128",
    d: "M92.644,180.258s-6.374,1.851-11.309,1.028-7.607,3.291-4.933,6.786,16.038,1.644,17.27,1.028S95.316,182.93,92.644,180.258Z",
    transform: "translate(87.023 208.198)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309129",
    "data-name": "Path 309129",
    d: "M97.054,204.335s70.255-28.862,95.318-42.533,43.292-9.493,43.292,5.316-20.507,24.686-36.835,31.9-79.748,22.026-86.963,23.164a82.815,82.815,0,0,0-8.355,1.519s-3.8,4.179-4.937,4.558-16.71-2.278-16.71-2.278,3.8-7.976,2.659-11.394-2.28-7.215-2.28-7.215,8.734-6.456,14.811-3.039",
    transform: "translate(94.552 177.279)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309130",
    "data-name": "Path 309130",
    d: "M97.054,204.335s70.255-28.862,95.318-42.533,43.292-9.493,43.292,5.316-20.507,24.686-36.835,31.9-79.748,22.026-86.963,23.164a82.815,82.815,0,0,0-8.355,1.519s-3.8,4.179-4.937,4.558-16.71-2.278-16.71-2.278,3.8-7.976,2.659-11.394-2.28-7.215-2.28-7.215S90.977,200.917,97.054,204.335Z",
    transform: "translate(94.552 177.279)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25777",
    "data-name": "Rectangle 25777",
    width: 41.785,
    height: 35.898,
    transform: "translate(410.368 226.952)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25778",
    "data-name": "Rectangle 25778",
    width: 41.785,
    height: 35.898,
    transform: "translate(410.368 226.952)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25779",
    "data-name": "Rectangle 25779",
    width: 41.785,
    height: 28.666,
    transform: "translate(410.368 234.184)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25780",
    "data-name": "Rectangle 25780",
    width: 41.785,
    height: 28.666,
    transform: "translate(410.368 234.184)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25781",
    "data-name": "Rectangle 25781",
    width: 83.013,
    height: 45.994,
    transform: "translate(335.488 222.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25782",
    "data-name": "Rectangle 25782",
    width: 83.013,
    height: 45.994,
    transform: "translate(335.488 222.185)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25783",
    "data-name": "Rectangle 25783",
    width: 83.013,
    height: 45.994,
    transform: "translate(332.963 222.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25784",
    "data-name": "Rectangle 25784",
    width: 83.013,
    height: 45.994,
    transform: "translate(332.963 222.185)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25785",
    "data-name": "Rectangle 25785",
    width: 20.766,
    height: 20.766,
    transform: "translate(360.803 233.264)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25786",
    "data-name": "Rectangle 25786",
    width: 20.766,
    height: 20.766,
    transform: "translate(360.803 233.264)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25787",
    "data-name": "Rectangle 25787",
    width: 41.788,
    height: 35.898,
    transform: "translate(2.685 309.587)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25788",
    "data-name": "Rectangle 25788",
    width: 41.788,
    height: 35.898,
    transform: "translate(2.685 309.587)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25789",
    "data-name": "Rectangle 25789",
    width: 41.788,
    height: 28.666,
    transform: "translate(2.685 316.819)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25790",
    "data-name": "Rectangle 25790",
    width: 41.788,
    height: 28.666,
    transform: "translate(2.685 316.819)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25791",
    "data-name": "Rectangle 25791",
    width: 83.013,
    height: 45.994,
    transform: "translate(36.338 304.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25792",
    "data-name": "Rectangle 25792",
    width: 83.013,
    height: 45.994,
    transform: "translate(36.338 304.818)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25793",
    "data-name": "Rectangle 25793",
    width: 83.013,
    height: 45.994,
    transform: "translate(38.861 304.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25794",
    "data-name": "Rectangle 25794",
    width: 83.013,
    height: 45.994,
    transform: "translate(38.861 304.818)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309131",
    "data-name": "Path 309131",
    d: "M58.627,159.42a13.268,13.268,0,1,1-13.268-13.268A13.27,13.27,0,0,1,58.627,159.42",
    transform: "translate(37.064 168.806)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5018",
    "data-name": "Ellipse 5018",
    cx: 13.268,
    cy: 13.268,
    r: 13.268,
    transform: "translate(69.154 314.957)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.456
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEdit);
export default __webpack_public_path__ + "static/media/Dashboard_Edit.0dad9a49dbb1ba2c744558ffc6913194.svg";
export { ForwardRef as ReactComponent };